var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Module, VuexModule, Mutation, Action } from 'vuex-class-modules';
import { ROLEENUM, LIBELLEROLEENUM } from '../models/role.model';
import { HttpAuthTokenHelper } from '../utils/token.helper';
let UserModule = class UserModule extends VuexModule {
    constructor() {
        super(...arguments);
        this._userConnected = null;
        this._needToReconnect = false;
        this._needToDeconnect = false;
    }
    enterNeedToReconnect(needToReconnect) {
        this._needToReconnect = needToReconnect;
    }
    enterNeedToDeconnect(needToDeconnect) {
        this._needToDeconnect = needToDeconnect;
    }
    updateUserConnected(user) {
        this._userConnected = user;
    }
    setNeedToReconnect(needToReconnect) {
        return __awaiter(this, void 0, void 0, function* () {
            this.enterNeedToReconnect(needToReconnect);
        });
    }
    setNeedToDeconnect(needToDeconnect) {
        return __awaiter(this, void 0, void 0, function* () {
            this.enterNeedToDeconnect(needToDeconnect);
        });
    }
    initUserConnectedFromToken(canReconnect = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((!canReconnect && HttpAuthTokenHelper.isExpired()) || (canReconnect && HttpAuthTokenHelper.isExpiredSinceOneHour()))
                return null;
            const userConnected = HttpAuthTokenHelper.decode();
            if (!userConnected)
                return null;
            return this.updateUserConnected(userConnected);
        });
    }
    isUserManager() {
        var _a;
        return ((_a = this._userConnected) === null || _a === void 0 ? void 0 : _a.idr) === ROLEENUM.MANAGER_CARE_SANTE;
    }
    isUserCare() {
        var _a, _b, _c;
        return (((_a = this._userConnected) === null || _a === void 0 ? void 0 : _a.idr) === ROLEENUM.CARE_COTISATION_SANTE_JUNIOR ||
            ((_b = this._userConnected) === null || _b === void 0 ? void 0 : _b.idr) === ROLEENUM.CARE_COTISATION_SANTE_CONFIRME ||
            ((_c = this._userConnected) === null || _c === void 0 ? void 0 : _c.idr) === ROLEENUM.CARE_COTISATION_SANTE_EXPERT);
    }
    getUserRole() {
        if (this.isUserCare())
            return LIBELLEROLEENUM.CARE;
        if (this.isUserManager())
            return LIBELLEROLEENUM.MANAGER;
        return LIBELLEROLEENUM.ADHERENT;
    }
    get userConnected() {
        return this._userConnected;
    }
    get needToReconnect() {
        return this._needToReconnect;
    }
    get needToDeconnect() {
        return this._needToDeconnect;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, "enterNeedToReconnect", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, "enterNeedToDeconnect", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserModule.prototype, "updateUserConnected", null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", Promise)
], UserModule.prototype, "setNeedToReconnect", null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", Promise)
], UserModule.prototype, "setNeedToDeconnect", null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], UserModule.prototype, "initUserConnectedFromToken", null);
UserModule = __decorate([
    Module
], UserModule);
export { UserModule };
